(function ($) {
  const initializeBlock = function ($block) {
    function switchContent(target = 1, $this = false) {
      if ($this) {
        // reset content
        $this.closest('.tabsContent').find('.tabsContent-title').removeClass('active')
        $this.closest('.tabsContent').find('.acf-innerblocks-container .block').removeClass('active')
        $this.closest('.tabsContent').find('.acf-innerblocks-container .block').addClass('inactive')

        // set content
        $this.closest('.tabsContent').find('.tabsContent-title:nth-child(' + target + ')').first().addClass('active')
        $this.closest('.tabsContent').find('.tabsContent-content .acf-innerblocks-container .block:nth-child(' + target + ')').first().addClass('active')
        $this.closest('.tabsContent').find('.tabsContent-content .acf-innerblocks-container .block:nth-child(' + target + ')').first().removeClass('inactive')

      } else {
        // reset content
        $block.find('.tabsContent-title').removeClass('active')
        $block.find('.acf-innerblocks-container .block').removeClass('active')
        $block.find('.acf-innerblocks-container .block').addClass('inactive')

        // set content
        $block.find('.tabsContent-title:nth-child(' + target + ')').first().addClass('active')
        $block.find('.tabsContent-content .acf-innerblocks-container .block:nth-child(' + target + ')').first().addClass('active')
        $block.find('.tabsContent-content .acf-innerblocks-container .block:nth-child(' + target + ')').first().removeClass('inactive')
      }
    }
    switchContent()

    $('.tabsContent-title').click(function(event) {
      event.preventDefault()
      var target = $(this).attr('data-target')
      switchContent(target, $(this))
    });
  };

  $(document).ready(function () {
    $(".block--tabs-content").each(function () {
      initializeBlock($(this));
    });
  });

  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=tabs-content",
      initializeBlock
    );
  }
})(jQuery);
